define(function (require) {
    "use strict";

    var LE = require("app");
    var BaseModel = require("models/BaseModel");
    var ManagerConfig = require("manager-assets/config/managerConfig.json");

    var KEYS = {
        ID: "id",
        PARENT_ID: "parentId",
        NAME: "name",
        SDE_NAME: "SDEName",
        SDE_PATH: "SDEPath",
        IS_EDITABLE: "isEditable",
        IS_AGENT_EDITABLE: "isAgentEditable",
        MAP_BY_ID: "mapById",
        MAP_BY_VALUE: "mapByValue",
        AGENT_DISPLAY_NAME_VALUE: "agentDisplayNameValue",
        CLEANUP: "cleanup"
    };

    var DataSourcesPropertiesModel = {};
    LE.module("LEManager", function (LEManager, LE, Backbone, Marionette, $, _) {

        DataSourcesPropertiesModel = BaseModel.extend({
            name: "DataSourcesPropertiesModel",
            defaults : {
                id: null,
                parentId: null,
                name: "",
                SDEName: "",
                SDEPath: "",
                isEditable: false,
                isAgentEditable: false,
                mapById: -1,
                mapByValue: "",
                agentDisplayNameValue: null,
                cleanup: ""
            },

            validation:{
                "mapByValue":[
                    {
                        fn: function(propertyValue) {
                            if (this.isEditable()){
                                var mapId = this.getMapById();
                                var isJVariable = mapId === ManagerConfig.dataSources.mainConfig.scraper.MAP_BY_ENUM.JAVASCRIPT_VARIABLE;
                                var pattern = isJVariable ? new RegExp(/^[\w._\-]*$/) : new RegExp(/^[\w_\-]*$/);
                                if (!pattern.test(propertyValue)){
                                    return "LEManager.manager.dataSources.property.value.invalid";
                                }
                                if ((propertyValue === "" || _.isUndefined(propertyValue)) && (!(mapId === -1 || _.isUndefined(mapId) || mapId === ""))){
                                    return "LEManager.manager.dataSources.edit.validation.propertyValue.required";
                                }
                            }
                        }
                    }

                ],
                "mapById": [
                    {
                        fn: function(mapId) {
                            if (this.isEditable()){
                                var propertyValue = this.getMapByValue();
                                if ((mapId === -1 || _.isUndefined(mapId) || mapId === "") && (!(propertyValue === "" || _.isUndefined(propertyValue)))) {
                                    return "LEManager.manager.dataSources.edit.validation.mapBy.required";
                                }
                            }
                        }
                    }
                ]
            },

            initialize: function(options){
            },

            getId: function(){
                return this.get(KEYS.ID);
            },
            getLogicalName: function(){
                return this.get(KEYS.NAME);
            },
            getName: function(){
                return LE.translator.translate('LEManager.manager.dataSources.property.' + this.getLogicalName() + ".name");
            },
            getSDEName: function(){
                return this.get(KEYS.SDE_NAME);
            },
            getSDEPath: function(){
                return this.get(KEYS.SDE_PATH);
            },
            isEditable: function(){
                return this.get(KEYS.IS_EDITABLE);
            },
            isAgentEditable: function(){
                return this.get(KEYS.IS_AGENT_EDITABLE);
            },
            getParentId: function(){
                return this.get(KEYS.PARENT_ID);
            },
            getMapById: function(){
                return this.get(KEYS.MAP_BY_ID);
            },
            getMapByValue: function(){
                return this.get(KEYS.MAP_BY_VALUE);
            },
            getCleanup: function(){
                return this.get(KEYS.CLEANUP);
            },
            setMapById: function(id, options){
                id = (_.isUndefined(id)) ? -1 : id; //fallback in case not saved correctly
                if (!_.isUndefined(options)){
                    this.set(KEYS.MAP_BY_ID, id, options);
                }
                else {
                    this.set(KEYS.MAP_BY_ID, id);
                }
            },
            setMapByValue: function(value, options){
                value = _.isUndefined(value) ? "" : value; //fallback in case not saved correctly
                if (!_.isUndefined(options)){
                    this.set(KEYS.MAP_BY_VALUE, value, options);
                }
                else {
                    this.set(KEYS.MAP_BY_VALUE, value);
                }
            },
            getAgentDisplayNameValue: function(){
                return this.get(KEYS.AGENT_DISPLAY_NAME_VALUE);
            },
            setAgentDisplayNameValue: function(value, options){
                if (!_.isUndefined(options)){
                    this.set(KEYS.AGENT_DISPLAY_NAME_VALUE, value, options);
                }
                else {
                    this.set(KEYS.AGENT_DISPLAY_NAME_VALUE, value);
                }
            },
            arePropertiesBlank: function(agent){
                var val;
                if (agent) {
                    val = this.getAgentDisplayNameValue();
                    return _.isUndefined(val) || null === val;
                }

                return this.getMapById() === -1 && this.getMapByValue() === "";
            },
            hasMissingProperties: function(){
                return this.getMapById() === -1 || this.getMapByValue() === "";
            },
            hasAgentOutcomePropertyChanges: function(){
                return this.hasChanged() && _.has(this.changedAttributes(), KEYS.AGENT_DISPLAY_NAME_VALUE);
            },
            hasScrapingPropertyChanges: function () {
                return this.hasChanged() && (_.has(this.changedAttributes(), KEYS.MAP_BY_ID) || _.has(this.changedAttributes(), KEYS.MAP_BY_VALUE));
            }

        });
    });

    DataSourcesPropertiesModel.KEYS = KEYS;

    return DataSourcesPropertiesModel;
});
